<template>
    <hot-dropdown
      class="menu-more-tools"
      slot="header-actions"
      @open="onOpenDropdown"
      @close="onCloseDropdown"
      tabindex="0"
      @keyup.enter="toggleTab"
      @keyup.space="toggleTab"
    >
      <hot-menu-item
        id="header-avatar"
        class="dropdown-button _rounded-lg"
        :class="{'_bg-gray-200': isActive}"
        slot="button"
      >
        <div class="hot-application-menu__icon">
          <hot-avatar
            :src="imageSrc"
            id="avatar-image"
            class="hot-avatar--circle"
            :class="{'_border-sm': isActive, '_border-brand-primary': isActive, '_text-brand-primary': isActive,}"
          />
        </div>
      </hot-menu-item>
      <div class="_py-3" slot="menu">
        <hot-dropdown-menu-item v-for="({ urlToRedirect, text}, index) in menuItems" class="_d-flex _px-5 _py-4" :key="index" @click="openPage(urlToRedirect)">
            {{ text }}
        </hot-dropdown-menu-item>
        <hot-dropdown-menu-divider slot="menu"></hot-dropdown-menu-divider>
        <hot-dropdown-menu-item class="_d-flex _px-5 _py-4 _align-items-center" @click.prevent="logoutCheck">
          <font-awesome-icon :icon="['far', 'sign-out']" class="_mr-4 _text-brand-primary"/>
          {{ $t('commonText.exit') }}
        </hot-dropdown-menu-item>
      </div>
    </hot-dropdown>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'

  export default {
    name: 'header-avatar',
    data: () => ({
      isActive: false,
      imageError: false
    }),
    computed: {
      ...mapState('auth', [
        'currentProduct'
      ]),
      ...mapState('builder', [
        'templateHasUnsavedChanges'
      ]),
      ...mapGetters('auth', ['userPhotoUrl']),
      imageSrc () {
        return this.imageError ? 'assets/images/no-photo-user.jpg' : this.userPhotoUrl
      },
      menuItems () {
        return [
          {
            urlToRedirect: process.env.APP_URL.concat('accounts/settings'),
            text: this.$t('header.menuTab.options.myAccount.title'),
            newTab: false
          },
          {
            urlToRedirect: 'https://extensions.buildstaging.com/login',
            text: this.$t('header.menuTab.options.myExtensions.title'),
            newTab: true
          },
          {
            urlToRedirect: process.env.APP_URL.concat('communication'),
            text: this.$t('header.menuTab.options.communications.title'),
            newTab: false
          }
        ]
      }
    },
    methods: {
      ...mapActions('auth', {
        logoutUser: 'LOGOUT_USER'
      }),
      logoutCheck () {
        if (this.templateHasUnsavedChanges) {
          this.setUnsavedWarning({show: true, logout: true})
          return false
        }

        this.logout()
      },
      async logout () {
        await this.logoutUser({triggeredByUser: true})
      },
      openPage (url, newTab) {
        window.open(url, newTab ? '_blank' : '_self')
      },
      onOpenDropdown () {
        this.closeNotificationsDialog()
        this.isActive = true
      },
      onCloseDropdown () {
        this.isActive = false
      },
      closeNotificationsDialog () {
        this.$event.emit('close:user-notifications-dialog')
      },
      onImageError () {
        this.imageError = true
      },
      toggleTab () {
        this.$emit('toggleTab', 'header-avatar')
      }
    },
    mounted () {
      document.getElementById('avatar-image').firstChild.addEventListener('error', this.onImageError)
    }
  }
</script>

<style lang="scss" scoped>
    @import '~stylesheets/meta';
</style>
